<template>
	<div
		class="tooltip"
		:class="[
			!!scan ? 'tooltip--scan tooltip--scan-' + scan : '',
			'tooltip--' + placement
		]"
		v-html="content"
		:style="style"
	>
	</div>
</template> 
<script>
	export default {
		name: 'Tooltip',
		props: {
			content: {
				type: String,
				default: 'Texte de l’info-bulle',
			},
			focusEl: {
				type: SVGPathElement,
				default: () => {},
			},
			parentEl: {
				type: HTMLDivElement,
				default: () => document.createElement('div'), 
			},
			placement: {
				type: String,
				default: 'mouse',
			},
			offset: {
				type: Number,
				default: 30,
			},
			fixed: {
				type: Object,
				default: () => {
					return {
						top: '25%',
						left: '25%',
					}
				},
			},
			width: {
				type: Number,
				default: -1, 
			},
			minWidth: {
				type: Number,
				default: -1,
			},
			fontSize: {
				type: Number,
				default: 1.6,
			},
			scan: {	// 'alert' or 'info' to use scan style
				type: String,
				default: null,
			},
			mouseOffset: {
				type: Object,
				default: () => {
					return {
						top: 40,
						left: -50,
					}
				}
			},
		},
		data: function() {
			return {
				rectEl: null,
				rectParent: null,
				position: {
					top: '25px',
					left: '25px',
					bottom: 'unset',
					right: 'unset',
				}
			}
		},
		computed: {
			style: function() {
				let style = {}
			//	if (!this.$el) return style

				// Tooltip width and font size
				style.width = this.width == -1 ? '' : this.width + 'px'
				style.minWidth = this.minWidth == -1 ? '' : this.minWidth + 'px'
				style.fontSize = this.fontSize + 'rem'            

				// Fixed tooltip
				if (this.placement == 'fixed') {
					style.position == 'absolute'
					for (let key in this.fixed) {
						style[key] = this.fixed[key]
					}
				}

				// Place tooltip according to element
				if (this.placement == 'element' && !!this.rectEl && !!this.rectParent) {
					if (this.rectEl.top - this.rectParent.top < this.rectParent.height / 2) {
						
						// Place tooltip south of the focus element
						style.bottom = 'unset'
						style.top = (this.rectEl.top - this.rectParent.top + this.offset) + 'px'
					} else {

						// Place tooltip north of the focus element
						style.top = 'unset'
						style.bottom = (this.rectParent.height - (this.rectEl.top - this.rectParent.top) + this.offset / 2) + 'px'
					}
					if (this.rectEl.left - this.rectParent.left < this.rectParent.width / 2) {

						// Place tooltip west of the focus element
						style.right = 'unset'
						style.left = (this.rectEl.left - this.rectParent.left + this.offset) + 'px'
					} else {

						// Place tooltip east of the focus element
						style.left = 'unset'
						style.right = (this.rectParent.width - (this.rectEl.left - this.rectParent.left) + this.offset / 2) + 'px'
					}
				}


				return style
			}
		},
		mounted() {
			if (this.placement == 'element') {
				this.$nextTick(() => {
					this.rectEl = this.focusEl.getBoundingClientRect()
					this.rectParent = this.parentEl.getBoundingClientRect()
				})

			}
			
			// Place tooltip according to mouse position
			if (this.placement == 'mouse') {
				this.$el.parentNode.addEventListener('mousemove', (evt) => {
					console.log('la souris bouge')
					this.position.top = (evt.offsetY + this.mouseOffset.top) + 'px'
					this.position.left = (evt.offsetX + this.mouseOffset.left) + 'px'
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import 'global/css/contexte.apps.fonts';
	@import 'global/css/contexte.apps.colors.2.0';
	.tooltip {
		background-color: white;
		max-width: 250px;
		z-index: 1000;
		line-height: 1.2;
		white-space: normal;
		padding: 8px;
		position: absolute;
		box-shadow: 
			0 3px 6px rgba(0,0,0,0.16), 
			0 3px 6px rgba(0,0,0,0.23);
		font: 400 0.8em $sans;
		color: $dark-grey;
		&--scan {
			@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap');
			@import 'global/css/contexte.apps.colors.2.0';
			background-color: $blue-scan; 
			box-shadow: none;
			color: white;
			font-family: 'Inter', sans-serif !important;
			border-radius: 3px;
			line-height: 1.4 !important;
			&::before {
				content: '';
				display: block;
				width: 0;
				height: 0;
				position: absolute;
				border-left: 8px solid transparent;
				border-right: 8px solid transparent;
				border-bottom: 8px solid $blue-scan;
				left: 20px;
				top: -7px;
			}
			&-alert {
				background-color: $red-scan;
				&::before {
					border-bottom-color: $red-scan;
				}
			}
		}
	}
</style>